// extracted by mini-css-extract-plugin
module.exports = {"video":"youtube_video__xdufE"};